import { CancelButton } from '@src/main/shared/ui/components/button/cancel/CancelButton';
import { DeleteButton } from '@src/main/shared/ui/components/button/delete/DeleteButton';
import { ConfirmDialog } from 'primereact/confirmdialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ConfirmDeleteDialog.module.scss';

interface ConfirmDeleteDialogProps {
  visible: boolean;
  message?: string;
  confirmDelete: () => void;
  rejectDelete: () => void;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  visible,
  message,
  confirmDelete,
  rejectDelete,
}) => {
  const { t } = useTranslation();

  const footer = (
    <div className={styles.dialogFooter}>
      <CancelButton onClick={rejectDelete} />
      <DeleteButton onClick={confirmDelete} />
    </div>
  );

  return (
    <ConfirmDialog
      visible={visible}
      breakpoints={{ '960px': '75vw', '640px': '100vw' }}
      style={{ width: '50vw' }}
      message={
        <div className={styles.dialogMessage}>
          <i className={`pi pi-exclamation-triangle ${styles.dialogIcon}`} />
          <span>{message ?? t('common.message.confirmDelete')}</span>
        </div>
      }
      header={t('common.delete')}
      onHide={rejectDelete}
      footer={footer}
    />
  );
};

export default ConfirmDeleteDialog;
